export type ActionKey =
	| 'Back'
	| 'BackToOverview'
	| 'Choose'
	| 'Close'
	| 'ContactUs'
	| 'Get'
	| 'GoTo'
	| 'GoToContent'
	| 'GoToHomePage'
	| 'GoToResult'
	| 'LogOn'
	| 'LogOff'
	| 'MoreAbout'
	| 'Next'
	| 'Open'
	| 'ReadAloud'
	| 'ReadMore'
	| 'ReadMoreAbout'
	| 'Register'
	| 'RemoveFilter'
	| 'RenewCookieAccept'
	| 'Restart'
	| 'SeePrivacyPolicy'
	| 'Show'
	| 'Start'
	| 'SubscribeWithRSS';

interface DictionaryFunctions {
	get(key: ActionKey): string;
}

export const ActionItems = (getValue: (key: string, defaultValue?: string) => string): DictionaryFunctions => {
	return {
		get: (key: ActionKey): string => {
			switch (key) {
				case 'Back':
					return getValue('Actions.Back', 'Tilbage');
				case 'BackToOverview':
					return getValue('Actions.BackToOverview', 'Tilbage til oversigt');
				case 'Choose':
					return getValue('Actions.Choose', 'Vælg');
				case 'Close':
					return getValue('Actions.Close', 'Luk');
				case 'ContactUs':
					return getValue('Actions.ContactUs', 'Ring til os');
				case 'Get':
					return getValue('Actions.Get', 'Hent');
				case 'GoTo':
					return getValue('Actions.GoTo', 'Gå til');
				case 'GoToContent':
					return getValue('Actions.GoToContent', 'Gå til indhold');
				case 'GoToHomePage':
					return getValue('Actions.GoToHomePage', 'Gå til forsiden');
				case 'GoToResult':
					return getValue('Actions.GoToResult', 'Gå til resultat');
				case 'LogOn':
					return getValue('Actions.LogOn', 'Log på');
				case 'LogOff':
					return getValue('Actions.LogOff', 'Log af');
				case 'MoreAbout':
					return getValue('Actions.MoreAbout', 'Mere om');
				case 'Next':
					return getValue('Actions.Next', 'Næste');
				case 'Open':
					return getValue('Actions.Open', 'Åben');
				case 'ReadAloud':
					return getValue('Actions.ReadAloud', 'Læs op');
				case 'ReadMore':
					return getValue('Actions.ReadMore', 'Læs mere');
				case 'ReadMoreAbout':
					return getValue('Actions.ReadMoreAbout', 'Læs mere om');
				case 'Register':
					return getValue('Actions.Register', 'Tilmeld');
				case 'RemoveFilter':
					return getValue('Actions.RemoveFilter', 'Fjern filter');
				case 'RenewCookieAccept':
					return getValue('Actions.RenewCookieAccept', 'Forny cookie tilladelse');
				case 'Restart':
					return getValue('Actions.Restart', 'Start forfra');
				case 'SeePrivacyPolicy':
					return getValue('Actions.SeePrivacyPolicy', 'Se privatlivspolitik.');
				case 'Show':
					return getValue('Actions.Show', 'Vis');
				case 'Start':
					return getValue('Actions.Start', 'Start');
				case 'SubscribeWithRSS':
					return getValue('Actions.SubscribeWithRSS', 'Abonner med RSS');
			}
		},
	};
};
